import { Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

import { useToastStore } from '~/store/useToastStore';

export default function Toast() {
  const { show, message, type, setShow } = useToastStore();
  const handleClose = () => {
    setShow({
      show: false,
      type: undefined,
      message: '',
    });
  };

  if (!show) return null;

  return (
    <Snackbar open={show} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={type} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
